import { createActionsHook } from 'src/lib/sweetState';

import { ProjectStore } from './ProjectStore';

export const useProjectActions = createActionsHook(ProjectStore);
